import { C } from '../../theme.js';
import { FieldLabel } from '../../components/Primitives.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function CaseInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Case</FieldLabel>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        {[
          { id: 'lower', label: 'lowercase', eg: 'paris' },
          { id: 'upper', label: 'UPPERCASE', eg: 'PARIS' },
          { id: 'title', label: 'Title Case', eg: 'Paris' },
          { id: 'sentence', label: 'Sentence case', eg: 'Paris france' },
        ].map(m => {
          const on = (c.mode || 'lower') === m.id;
          return (
            <button key={m.id} onClick={() => u({ mode: m.id })}
              style={{
                fontFamily: 'inherit', cursor: 'pointer', textAlign: 'left',
                background: on ? 'var(--info-bg)' : C.input,
                color: on ? C.accentBright : C.fg3,
                border: `1px solid ${on ? C.accentMuted : C.border}`,
                borderRadius: 8, padding: '8px 10px',
                fontSize: '.78rem', fontWeight: 600,
              }}>
              <div>{m.label}</div>
              <div style={{ color: C.fg5, fontSize: '.7rem', marginTop: 2, fontFamily: "'JetBrains Mono', monospace" }}>{m.eg}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
